import React, {Component} from 'react';
import {gpn} from "../../GPN"
import Back from "../../sections/Back";
import req from "../../req";
import InfiniteScroll from "react-infinite-scroller";
import Field from "../../sections/MUI/Field";
import Icon from "../../sections/MUI/Icon";
import Modal from "../../sections/MUI/Modal";
import {toast} from "react-toastify";
import Button from "../../sections/MUI/Button";
import config from "../../config";
import Select from "../../sections/MUI/Select";
import jMoment from "jalali-moment";
import DateField from "../../sections/MUI/DateField";

const smsPatterns = config.smsPatterns;

class Users extends Component {

    state = {
        users: [],
        page: 1,
        hasNextPage: true,
        totalPages: null,

        search: "",
        sort: "create",
        start: "",
        end: "",

        estelam: "none",
        register: "none",

        code: "",

        ids: [],
        selectUser: false,
        downloadLink: "",

        modalSMS: -1,
        pattern: smsPatterns[0]
    };

    getUsers(page, search = "", sort = "create", estelam = "none", register = "none", start = "", end = "") {
        req.get(`/user/list?page=${page}&s=${search}&sort=${sort}&estelam=${estelam}&register=${register}&start=${start}&end=${end}`)
            .then(r => {
                const users = r;
                this.setState({
                    users: page > 1 ? [...this.state.users, ...users.docs] : users.docs,
                    page: page + 1,
                    hasNextPage: users.hasNextPage,
                    totalPages: users.totalPages
                });
            });

    }

    getCode(id = "") {
        toast.info("در حال دریافت ...");
        req.get(`/user/verification-code?id=${id}`)
            .then(r => {
                const {code} = r;
                this.setState({code});
            });
    }

    isActive(id = "") {
        let {ids} = this.state;
        return ids.includes(id);
    }

    handleItemClick(id = "") {
        let {ids} = this.state;

        let index = -1;

        ids.map((it, i) => {
            if (it.toString() === id.toString()) {
                index = i;
            }
        });

        if (index === -1) {
            ids.push(id);
        } else {
            ids.splice(index, 1);
        }
        this.setState({ids});
    }

    downloadPDF() {
        let {ids} = this.state;
        ids = ids ? ids : [];
        if (ids.length > 0) {
            toast.info("در حال تهیه گزارش ...");
            req.post(`/users/report`, {ids})
                .then(r => {
                    if (r) {
                        this.setState({downloadLink: r.url});
                    }
                })
        }
    }


    downloadPDFByMonth(month = "0") {
        month = month ? month : "0";
        if (month === "") month = "0";
        month = (Number(month || 0) || 0);
        if (isNaN(month)) month = 0;

        if (month <= 0) return toast.error("خطای ورودی ماه گزارش!");

        toast.info("در حال تهیه گزارش ...");
        req.post(`/users/report`, {ids: [], month})
            .then(r => {
                if (r) {
                    this.setState({downloadLink: r.url});
                    try {
                        window.open(r.url, "_blank");
                    } catch (err) {
                        document.location.href = r.url;
                    }
                }
            });

    }

    handleInputSearchChange(value = "") {
        this.setState({
            search: value
        });
        try {
            clearTimeout(this.timeout);
        } catch (err) {
        }
        this.timeout = setTimeout(() => {
            let {sort, estelam, register, start, end} = this.state;
            this.getUsers(1, value, sort, estelam, register, start, end);
        }, value.toString().trim() === "" ? 300 : 1000);
    };


    handlePatternChange(p = "") {
        let index = -1;
        smsPatterns.map((it, i) => {
            if (it.p === p) {
                index = i;
            }
        });
        if (index !== -1) {
            this.setState({pattern: smsPatterns[index]});
        }
    }

    sendSMS() {
        try {
            let {modalSMS, users} = this.state;
            let pattern = this.state.pattern.p;
            let patternText = this.state.pattern.t;

            let {fullName = "", phone = ""} = users[modalSMS];

            fullName = (String(fullName || "") || "").trim();
            phone = (String(phone || "") || "").trim();

            if (["", "-", "بدون نام", "undefined", "null"].includes(fullName)) {
                fullName = "کاربر قسطی تک";
            }

            toast.info("در حال ارسال ...");

            req.post(`/sms/send?token=${config.token}`, {
                phone, pattern, name: fullName, patternText
            })
                .then(r => {
                    toast.success("پیامک با موفقیت ارسال شد!");
                    this.setState({modalSMS: -1});
                });

        } catch (err) {
        }


    }

    customReport() {
        let {users = []} = this.state;
        users = users ? users : [];
        let ids = users?.map(u => {
            let {id, _id} = u;
            return id ? id : _id;
        });

        ids = ids ? ids : [];

        if (ids.length > 0) {
            toast.info("در حال تهیه گزارش ...");
            req.post(`/users/report`, {ids})
                .then(r => {
                    if (r) {
                        this.setState({downloadLink: r.url});
                    }
                })
        }
    }

    render() {
        let {
            users, page, hasNextPage, search, sort, estelam, register
            , code,
            selectUser, ids, downloadLink,
            modalSMS,
            pattern,
            start, end
        } = this.state;
        return (
            <div className="users">
                {
                    downloadLink?.toString().trim() !== "" ?
                        <Modal display={downloadLink?.toString().trim() !== ""}
                               title="گزارش"
                               onCloseClick={() => this.setState({downloadLink: ""})}>
                            <br/>
                            <div className="modal-report-users">
                                <div className="row justify-content-center">
                                    <a href={downloadLink} target="_blank">{downloadLink}</a>
                                </div>
                            </div>
                        </Modal>
                        : null
                }
                {
                    code !== "" ?
                        <Modal display={code !== ""}
                               onCloseClick={() => this.setState({code: ""})}
                               title="کد تایید">
                            <h1 className="code" style={{textAlign: "center", color: "#1f4d93"}}>{code}</h1>
                        </Modal>
                        : null
                }
                {
                    modalSMS !== -1 ?
                        <Modal display={modalSMS !== -1}
                               title="ارسال پیامک"
                               onCloseClick={() => this.setState({modalSMS: -1})}>
                            <div className="modal-send-sms">
                                <Select name="pattern"
                                        value={pattern.p}
                                        label="پترن"
                                        options={smsPatterns.map(it => {
                                            return {
                                                t: ["", "-", "بدون نام", "undefined", "null"].includes(users[modalSMS]?.fullName?.toString().trim()) ?
                                                    it.t.replace("%name%", "کاربر قسطی تک") : it.t.replace("%name%", users[modalSMS]?.fullName?.toString().trim()),
                                                v: it.p
                                            }
                                        })}
                                        onChange={(name, value) => this.handlePatternChange(value)}/>

                                <br/>
                                <br/>
                                <div className="row justify-content-center">
                                    <div className="col-md-5">
                                        <Button icon="check" onClick={() => this.sendSMS()}>ارسال پیامک</Button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        : null
                }
                <Back {...this.props}/>
                <br/>

                <br/>
                <div className="row justify-content-between">
                    <div className="col-md-4">
                        <div className={selectUser ? "select-user-btn active" : "select-user-btn"}
                             onClick={() => this.setState({selectUser: !selectUser})}>انتخاب
                            کاربر (PDF)
                        </div>
                    </div>
                    {
                        ids?.length > 0 ?
                            <div className="col-md-4">
                                <Button icon="download" onClick={() => this.downloadPDF()}>خروجی PDF</Button>
                            </div>
                            : null
                    }

                </div>
                <br/>
                <div className="row">
                    <div className="col-md">
                        <Button icon="download"
                                onClick={() => this.downloadPDFByMonth("1")}>1 ماه اخیر</Button>
                    </div>
                    <div className="col-md">
                        <Button icon="download"
                                onClick={() => this.downloadPDFByMonth("3")}>3 ماه اخیر</Button>
                    </div>
                    <div className="col-md">
                        <Button icon="download"
                                onClick={() => this.downloadPDFByMonth("6")}>6 ماه اخیر</Button>
                    </div>
                    <div className="col-md">
                        <Button icon="download"
                                onClick={() => this.downloadPDFByMonth("12")}>12 ماه اخیر</Button>
                    </div>
                    <div className="col-md">
                        <Button icon="download"
                                onClick={() => this.downloadPDFByMonth("24")}>24 ماه اخیر</Button>
                    </div>
                </div>
                <br/>

                <div className="row justify-content-center">
                    <div className="col-md-7">
                        <Field name="search"
                               value={search}
                               label="جستجو"
                               onChange={(name, value) => {
                                   this.handleInputSearchChange(value);
                               }}/>
                    </div>
                    <div className="col-md-5">
                        <Select
                            onChange={(n, v) => {
                                this.setState({sort: v});
                                this.getUsers(1, search, v, estelam, register, start, end);
                            }}
                            value={sort}
                            options={[
                                {t: "جدیدترین", v: "create"},
                                {t: "ویرایش", v: "update"}
                            ]}
                            placeholder="مرتب سازی بر اساس ..."/>
                    </div>

                    <div className="col-6">
                        <Select value={estelam}
                                name="estelam"
                                onChange={(n, v) => {
                                    this.setState({[n]: v});
                                    this.getUsers(1, search, sort, v, register, start, end);
                                }}
                                options={[
                                    {t: "بدون فیلتر", v: "none"},
                                    {t: "پرداخت شده", v: "true"}
                                ]}
                                label="هزینه استعلام"/>
                    </div>
                    <div className="col-6">
                        <Select value={register}
                                name="register"
                                onChange={(n, v) => {
                                    this.setState({[n]: v});
                                    this.getUsers(1, search, sort, register, v, start, end);
                                }}
                                options={[
                                    {t: "بدون فیلتر", v: "none"},
                                    {t: "پرداخت شده", v: "true"}
                                ]}
                                label="هزینه ثبت نام"/>
                    </div>
                </div>
                <br/>

                <div className="row justify-content-center">
                    <div className="col-6">
                        <DateField value={start} label="از تاریخ"
                                   onChange={(unix, formatted) => {
                                       this.setState({start: formatted});
                                       this.getUsers(1, search, sort, estelam, register, formatted, end)
                                   }}/>
                    </div>
                    <div className="col-6">
                        <DateField value={end} label="تا تاریخ"
                                   onChange={(unix, formatted) => {
                                       this.setState({end: formatted});
                                       this.getUsers(1, search, sort, estelam, register, start, formatted);
                                   }}/>
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-md-4">
                        <Button icon="download" onClick={() => this.customReport()}>خروجی از فیلتر فعلی</Button>
                    </div>
                </div>
                <br/>
                <div className="list">
                    <InfiniteScroll
                        pageStart={1}
                        loadMore={() => this.getUsers(page, search, sort, estelam, register, start, end)}
                        hasMore={hasNextPage}
                        loader={<div className="loader" key={0}>دریافت ...</div>}>
                        {
                            users ? users?.map((u, i) =>
                                    <article key={"user" + i}>
                                        <div className="row">
                                            {
                                                selectUser ?
                                                    <div className="col-auto">
                                                        <div
                                                            className={this.isActive(u.id) ? "rectangle active" : "rectangle"}
                                                            onClick={() => this.handleItemClick(u.id)}>

                                                            <Icon i="check"/>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            <div className="col">
                                                <div className="row">

                                                    <div className="col-auto">
                                                        <div className="full-name">
                                                            {u.fullName !== "" ? u.fullName : "بدون نام"}</div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="phone-number">{u.phone}</div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <div className="national-code">{u.nationalCode}</div>
                                                    </div>
                                                </div>
                                                <div className="estelam-is-paid"><span
                                                    style={{
                                                        fontWeight: "bold",
                                                        margin: 8,
                                                        fontSize: "10pt",
                                                        textAlign: "center",
                                                        color: u.estelamIsPaid ? "#086c08" : "#8e0b0b"
                                                    }}>{u.estelamIsPaid ? "هزینه استعلام پرداخت شده است" : "هزینه استعلام پرداخت نشده است"}</span>
                                                </div>
                                                <div className="payment-amount">
                                                    <span>پرداختی ثبت نام:</span><span style={{
                                                    color: u.paymentAmount > 0 ? "#088108" : "#414141"
                                                }}>{config.priceFormatter(u.paymentAmount)}</span>
                                                </div>
                                                <div className="created-at">{u.createdAt}</div>
                                            </div>

                                            <div className="col-auto">
                                                <Icon i="message" className="message-icon"
                                                      onClick={() => this.setState({modalSMS: i})}/>
                                                <Icon i="key" className="code-icon"
                                                      onClick={() => this.getCode(u.id)}/>
                                                <Icon i="edit" className="edit-icon"
                                                      onClick={() => {
                                                          try {
                                                              window.open(`/user/${u.id}`, "_blank");
                                                          } catch (err) {
                                                              this.props.navigate(`/user/${u.id}`);
                                                          }
                                                      }}/>
                                            </div>
                                        </div>


                                    </article>)
                                : null
                        }
                    </InfiniteScroll>
                </div>

            </div>
        );
    }
}

export default gpn(Users);